import React from 'react'
import { useUser } from '@fs/zion-user'
import usePerson from '../../services/usePerson'
import WelcomeBanner from './WelcomeBanner'

export default function AncestorsPageHeader(): JSX.Element {
  const person = usePerson()
  const { signedIn } = useUser()
  const showWelcomeBanner = signedIn

  return <div>{showWelcomeBanner && <WelcomeBanner person={person} />}</div>
}
